/** Do not edit directly **/
*,
:host,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  grid-row: auto auto;
  grid-column: auto auto;
}